<div class="component-main">
    <div class="content-space-between">
        <h1 id="component-title">{{ 'csv_importer_import_users' | myLbTranslate }}</h1>
    </div>
    <app-table
        id="portal-import-list"
        [data]="tableRows">
        <app-column
            [flexGrow]="1"
            prop="status"
            label="status"
            [cellTemplate]="errorColumn">
            <ng-template let-row #errorColumn>
                <ng-container *ngIf="rowStatus[row.id]">
                    <img
                        *ngIf="rowStatus[row.id]?.type === 'error'"
                        ngSrc="./assets/shared/icons/notification-solid-exclamation-triangle.svg"
                        class="error-icon"
                        alt="Expiry icon"
                        height="20"
                        width="20"/>
                    <div *ngIf="rowStatus[row.id]?.type === 'active'" class="loader"></div>
                    <span [class]="rowStatus[row.id].message">{{ rowStatus[row.id].message | sentenceCase }}</span>
                </ng-container>
            </ng-template>
        </app-column>
        <app-column [flexGrow]="1" prop="email" label="email"></app-column>
        <app-column [flexGrow]="1" prop="roles" label="roles"></app-column>
        <app-column [flexGrow]="1" prop="groups" label="groups"></app-column>
        <app-column [flexGrow]="1" prop="disabled" label="disabled"></app-column>
    </app-table>
</div>

<div class="component-footer">
    <button id="portal-import-cancel" class="outline" (click)="backToParentRoute()">
        {{ 'cancel' | myLbTranslate }}
    </button>
    <app-loading-button
        buttonId="portal-import-submit"
        buttonClass="primary"
        buttonText="submit"
        [callBack]="submitUsers.bind(this)">
    </app-loading-button>
</div>

